import { useStore } from '@data/store'
import { CurrentRegistrationUserSlice } from '@data/store/slices/currentRegistrationUser'

export const setCurrentRegistrationUser: CurrentRegistrationUserSlice['setCurrentRegistrationUser'] =
    useStore.getState().currentRegistrationUser.setCurrentRegistrationUser
